/**
 * @fileoverview
 * Utility function to detect locale from saved preference, browser setting,
 * or parameter on the URL.
 */

import queryString from 'query-string';

/**
 * Priority order:
 * 1. URL parameter (?locale= or ?lang=)  — explicit override
 * 2. localStorage (scratch_locale)        — saved user preference
 * 3. Browser language                     — automatic detection
 * 4. 'en'                                 — fallback
 *
 * @param {Array.string} supportedLocales An array of supported locale codes.
 * @return {string} the preferred locale
 */
const detectLocale = supportedLocales => {
    let locale = 'en'; // default

    // --- browser language ---
    let browserLocale = window.navigator.userLanguage || window.navigator.language;
    browserLocale = browserLocale.toLowerCase();
    if (supportedLocales.includes(browserLocale)) {
        locale = browserLocale;
    } else {
        browserLocale = browserLocale.split('-')[0];
        if (supportedLocales.includes(browserLocale)) {
            locale = browserLocale;
        }
    }

    // --- saved preference (localStorage) overrides browser ---
    try {
        const saved = localStorage.getItem('scratch_locale');
        if (saved && supportedLocales.includes(saved)) {
            locale = saved;
        }
    } catch (_) { /* private browsing / blocked */ }

    // --- URL parameter has highest priority ---
    const queryParams = queryString.parse(location.search);
    const potentialLocales = [].concat(queryParams.locale, queryParams.lang).filter(l => l);
    if (potentialLocales.length) {
        const urlLocale = potentialLocales[0].toLowerCase();
        if (supportedLocales.includes(urlLocale)) {
            return urlLocale;
        }
    }

    return locale;
};

export {
    detectLocale
};
